import { objectToCamelCase, objectToSnakeCase } from '../utils'

import Organization from '../organizations'
import api from './api'

export default class Employee {
  static api = api.create(Employee)
  static readOnlyFields = ['id', 'changedFields']

  // TODO: Alter / Create constructor that simply takes in json, use Object.assign() to create 
  //       an object entirely based on what was given from the backend, this will then be used
  //       as a means to determine what information users/orgs/etc. have access to on frontend

  constructor(json) {
    Object.assign(this, { ...json })
    // Only grab the first value in the tuple so other code doesn't have to change because that is the amount
    this.totalPayoutsSinceLastGrantLimitReset = this.totalPayoutsSinceLastGrantLimitReset ? this.totalPayoutsSinceLastGrantLimitReset[0] : 0 
    this.totalNumberPayoutsSinceLastGrantLimitReset = this.totalPayoutsSinceLastGrantLimitReset ? this.totalPayoutsSinceLastGrantLimitReset[1] : 0
  }

  // constructor(employee = {}) {
  //   const {
  //     id = '',
  //     firstName = '',
  //     lastName = '',
  //     email = '',
  //     confirmEmail = '',
  //     fullName = '',
  //     paypalEmail = '',
  //     birthYear = null,
  //     zipCode = null,
  //     organizationRef = null,
  //     totalPayouts = null,
  //     totalContributions = null,
  //     netReceived = null,
  //     totalPayoutsSinceLastGrantLimitReset = null,
  //     employeeCodeRef = null,
  //     isStaff = null,
  //     isAdmin = null,
  //     isEmployee = null,
  //     isActive = null,
  //     isMonthlyDonor = null,
  //     datetimeCreated = null,
  //     hasSetNotifPreferences = null,
  //     enableEmailAlerts = null,
  //     enableSmsAlerts = null,
  //     enablePhoneContact = null,
  //     preferredLanguage = 'en_US',
  //     phoneNumber = '',
  //     rollingGrantDate = null,
  //     validatedNumber = null,
  //     changedFields = null,
  //     subOrganizationRef = {},
  //   } = employee
  //   Object.assign(this, {
  //     id,
  //     firstName,
  //     lastName,
  //     email,
  //     confirmEmail,
  //     fullName,
  //     paypalEmail,
  //     birthYear,
  //     zipCode,
  //     organizationRef: organizationRef ? Organization.fromAPI(organizationRef) : null,
  //     subOrganizationRef: subOrganizationRef
  //       ? { id: subOrganizationRef['id'], name: subOrganizationRef['name'] }
  //       : null,
  //     totalPayouts,
  //     totalContributions,
  //     netReceived,
  //     totalPayoutsSinceLastGrantLimitReset,
  //     employeeCodeRef,
  //     isStaff,
  //     isAdmin,
  //     isEmployee,
  //     isActive,
  //     isMonthlyDonor,
  //     datetimeCreated,
  //     hasSetNotifPreferences,
  //     enableEmailAlerts,
  //     enableSmsAlerts,
  //     enablePhoneContact,
  //     preferredLanguage,
  //     phoneNumber,
  //     rollingGrantDate,
  //     validatedNumber,
  //     changedFields,
  //   })
  // }

  static create(opts) {
    return new Employee(opts)
  }

  static fromAPI(json = {}) {
    return new Employee(objectToCamelCase(json))
  }

  /**
   * Prep data for the API. Can elect to include or exlude specific fields.
   * The `User.readOnlyFields` are always excluded.
   **/
  static toAPI(employee, fields = [], excludeFields = []) {
    // By default, send the whole object
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = employee[field]
      })
    } else {
      data = employee
    }

    //
    excludeFields = [...Employee.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    return objectToSnakeCase(data)
  }

  static checkIsInstance(obj, name) {
    if (!(obj instanceof Employee)) {
      throw Error(`${name} must be an instance of the Employee class.`)
    }
  }
}
